var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.63666 8.99992H0.666656V0.666587L1.63666 8.99992ZM1.63666 8.99992C2.74307 6.26347 4.72613 3.97143 7.27504 2.48302C9.82395 0.99461 12.7947 0.393942 15.7216 0.775154C18.6485 1.15637 21.3663 2.49791 23.4489 4.58955C25.5316 6.68118 26.8614 9.40469 27.23 12.3333M1.63666 8.99992H8.99999M26.365 18.9999H27.3333V27.3333L26.365 18.9999ZM26.365 18.9999C25.257 21.7348 23.2734 24.025 20.7247 25.5121C18.1761 26.9992 15.2062 27.5991 12.2802 27.218C9.35409 26.837 6.63699 25.4964 4.55421 23.4061C2.47144 21.3159 1.14058 18.594 0.769989 15.6666M26.365 18.9999H19",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.7486e2b3d55e9145ebe889da8347e1e7.svg";
export { ForwardRef as ReactComponent };